// import React, { Component } from 'react'
// import { Platform } from 'react-native'
import * as Linking from 'expo-linking'

import { StackNavigationOptions } from '@react-navigation/stack'
import * as variables from './variables'
import * as colors from './colors'
// import { HeaderBackButton } from '../components/Header'

const headerTitleStyle = {
  fontFamily: variables.FONT_FAMILY_BOLD,
  fontSize: variables.FONT_SIZE_HEADER,
  color: colors.black
}

const headerBackTitleStyle = {
  fontFamily: variables.FONT_FAMILY_BASE,
  fontSize: variables.FONT_SIZE_HEADER,
}

export const commonScreenOptions: StackNavigationOptions = {
  headerTitleStyle,
  headerBackTitleStyle,
  headerBackTitleVisible: false,
  headerTintColor: colors.blue
  // headerBack TintColor: colors.blue
}

const commonStackRoutes = {
  GenericResource: 'r/:resourceId/:slug/:name?',
  GenericLocations: 'location/:districtId',
  SuspicionCheckerAcuteDangerChildren: 'suspicion-checker-acute-danger',
  SuspicionCheckerLatentDangerChildren: 'suspicion-checker-latent-danger',
  SuspicionCheckerNeedForAdviceChildren: 'suspicion-checker-need-for-advice',
}

export const LinkingConfiguration = {
  prefixes: [Linking.makeUrl('/')],
  config: {
    screens: {
      SignedOut: {
        // path: 'root',
        screens: {
          Onboarding: 'onboarding',
          SignIn: 'sign-in',
          SignUp: 'sign-up',
          SignUpSecond: 'sign-up-2/:registrationCode',
        }
      },
      SignedIn: {
        // path: 'root',
        screens: {
          Start: {
            path: 'patientgroup',
            screens: {
              Start: 'home',
              StartOverviewChildren: 'children',
            }
          },
          Info: {
            path: 'info',
            screens: {
              Info: 'home',
              ...commonStackRoutes
            }
          },
          Documentation: {
            path: 'docs',
            screens: {
              Documentation: 'home',
              ...commonStackRoutes
            }
          },
          News: {
            path: 'news',
            screens: {
              News: 'home',
              NewsDetail: '/:newsId/:title?'
            }
          },
          Settings: {
            path: 'settings',
            screens: {
              Settings: 'home'
            }
          },
        }
      },
      ResetPassword: 'reset-password',
      VerifyEmailAddress: 'verify-email',
      NotFound: '*',
    }
  },
}
